import React, { useRef, useState } from 'react';
import './HeroSection.css';

const HERO_CONTENT = {
  badge: 'Creating Wealth For Families',
  titleLine1: 'The Will to Dream.',
  titleLine2: 'The Path to Wealth.',
  subtitle:
    'Empowering your financial future with trusted advice, strategic planning, and unwavering commitment. ' +
    'Powered by People. Built on Trust. Driven by Results.',
  primaryBtn: 'Start Your Journey',
  secondaryBtn: 'Whatsapp',
};

const CONTACT = {
  whatsapp: {
    number: '+19173466654',
    label: 'Message us on WhatsApp',
  },
};

const VIDEO_CONFIG = {
  type: 'youtube',
  videoId: 'ymxbrsUzApI',
};

function VideoPlayer({ config }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleEnded = () => setIsPlaying(false);

  if (config.type === 'youtube') {
    return (
      <div className="hero-video-ratio">
        <iframe
          src={`https://www.youtube.com/embed/${config.videoId}?autoplay=1&mute=1&loop=1&playlist=${config.videoId}&controls=0&showinfo=0&rel=0`}
          title="Hero Video"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="hero-video-ratio">
      <video
        ref={videoRef}
        src={config.src}
        poster={config.poster || ''}
        onEnded={handleEnded}
        playsInline
        preload="metadata"
      />

      <button
        className={`hero-play-btn ${isPlaying ? 'hidden' : ''}`}
        onClick={handlePlay}
        aria-label="Play video"
      >
        <div className="hero-play-icon" />
      </button>
    </div>
  );
}

function HeroSection() {
  const whatsappLink = `https://wa.me/${CONTACT.whatsapp.number.replace(/\D/g, '')}`;

  return (
    <section className="hero-section">
      <div className="hero-inner">
        <div className="hero-text">
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            <span className="hero-badge-text">{HERO_CONTENT.badge}</span>
          </div>

          <h1 className="hero-title">
            {HERO_CONTENT.titleLine1}
            <br />
            <span className="hero-title-highlight">
              {HERO_CONTENT.titleLine2}
            </span>
          </h1>

          <p className="hero-subtitle">{HERO_CONTENT.subtitle}</p>

          <div className="hero-buttons">
            <button className="hero-btn-primary">
              {HERO_CONTENT.primaryBtn}
            </button>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-btn-secondary"
              aria-label={CONTACT.whatsapp.label}
            >
              {HERO_CONTENT.secondaryBtn}
            </a>
          </div>
        </div>

        <div className="hero-video-col">
          <div className="hero-video-wrapper">
            <VideoPlayer config={VIDEO_CONFIG} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;